<template>
    <div class="h-100">
        <c-column-header v-if="showHeader" :label="'Katalog - ' + title" class="primary mb-1" :title-border = "true" />

        <div :id="'audit-scroll'+ type" class="scroll-area mt-0 white" @scroll = "onScroll">
            <div v-for="(entry, index) in entries" :key = "'cat_2_' + index"  style="width: calc(100% - 4px)" :id = "'entry-' + entry.catalogue.id">
                <p-audit-escalator-entry
                    v-if      = "isEscalator"
                    class     = "mb-1"
                    :audit-id = "auditId"
                    :entry    = "entry"
                    :country  = "country"
                    :enums    = "enums"
                    :editable = "showBudgetData"
                />
                <p-audit-catalog-entry
                    v-else
                    class             = "mb-1"
                    :audit-id         = "auditId"
                    :entry            = "entry"
                    :unit             = "unit"
                    :country          = "country"
                    :show-budget-data = "showBudgetData"
                />
            </div>
        </div>
    </div>
</template>

<script>

import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import PAuditCatalogEntry from "@/modules/audit/components/private/PAuditCatalogEntry.vue";
import PAuditEscalatorEntry from "@/modules/audit/components/private/PAuditEscalatorEntry.vue";
import Core from "@/modules/core/service/Core";
import { ESCALATOR } from "@/modules/audit/service/AuditType";

export default {
    name: "PAuditCatalogEntries",

    props: {
        auditId: {
            required: true
        },

        title: {

        },

        entries: {
        },

        type: {
        },

        unit: {

        },

        country: {

        },

        /** GBU type of the audit (HCIT-917); escalator entries have their own view. */
        deviceType: {

        },

        enums: {

        },

        showHeader: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showBudgetData: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () =>  ({
        scrollIndex: null,
    }),

    computed: {
        isEscalator () {
            return this.deviceType === ESCALATOR;
        },

        scroll () {
            return document.querySelector("#audit-scroll" + this.type);
        }
    },

    components: {
        PAuditEscalatorEntry,
        PAuditCatalogEntry,
        CColumnHeader
    },

    methods: {
        scrollTo (entry) {
            const element = document.querySelector("#entry-" + entry.id);
            Core.scroll.toVElement(this.scroll, element, 1);
        },

        onScroll () {
            const scrollTargets = [];
            this.entries.forEach(e => {
                if (e) {
                    scrollTargets.push("#entry-" + e.catalogue.id);
                }
            });

            this.scrollIndex = Core.scroll.menuIndex(this.scroll, scrollTargets)
            this.$emit("index", this.scrollIndex)
        },
    }
}
</script>

<style scoped>

.scroll-area {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(100% - 8px);
    width: calc(100% + 10px)!important;
}

</style>